const ITEMS = ["Glossy", "Matt", "Marble", "Carving", "Metallic", "Velvet+", "Endless", "Double Digital", "R-10 & R-11", "Core", "Evora", "Inlay", "Arenite", "Fenix Decor", "Oriss", "Colorica", "Authentic", "Laminate", "Punch", "Porsh", "GHR", "HG"];

export const Marquee = ({ dark = false }) => (
  <div data-testid="surface-marquee" className={`marquee relative overflow-hidden border-y py-6 ${dark ? "border-white/10 bg-[var(--navy)] text-white" : "border-slate-200 bg-white text-[var(--navy)]"}`}>
    <div className="marquee-track">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center gap-8 pr-8 font-display text-2xl font-light tracking-tight sm:text-3xl">
          {t}
          <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-[var(--mint-light)]" : "bg-[var(--mint)]"}`} />
        </span>
      ))}
    </div>
  </div>
);
